import React, { Fragment } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Divider } from 'antd';
import { moneda } from '../../../../helper';
import Slider from 'react-slick';

import './secciones.css'
// import Producto from '../../productosCarrito/producto';

const VersionesYPrecios = ({ versiones, tipoMoneda }) => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3500,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1360,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            }
        ]
    }

    let colLenght = 9;

    if (!versiones || versiones.length < 1) {
        return null;
    } else {
        if (versiones.length < 3) {
            settings.slidesToShow = versiones.length;
            colLenght = versiones.length * 4;
        }
    }
    return (
        <>
            <Row>
                <Col xs={10} md={colLenght} className="mx-auto my-ficha mb-5">
                    <Slider {...settings} className="slider-multiple">
                        {versiones && versiones.length > 0 &&
                            versiones.map((version, i) =>
                                <Tarjeta version={version} tipoMoneda={tipoMoneda} key={i} />
                            )
                        }
                    </Slider>
                </Col>
            </Row>
        </>
    );
};


const Tarjeta = ({ version, tipoMoneda }) => {
    if (!version) return null;

    return (
        <Container className="mb-5 border-versiones px-2 px-lg-0">
            <Row>
                <Col xs={12} md={10} className="mx-auto">
                    <h5 className="bold-title-hyundai mb-0 f-responsive-14">{version.Nombre}</h5>
                    <p className="parrafo-hyundai f-responsive mb-0">{version.Version}</p>
                </Col>
            </Row>
            <Row className="px-3 d-none">
                <Col xs={12} md={10} className="mx-auto border-carac">
                    <Row>
                        {version && version.caracteristicas && version.caracteristicas.length > 0 &&
                            version.caracteristicas.map((caracteristica, index) =>
                                <Col className={`mx-auto text-center ${index + 1 < version.caracteristicas.length && "border-intermedio"}`} key={index}>
                                    <img
                                        src={caracteristica.Imagen}
                                        alt={caracteristica.Descripcion}
                                        className="mr-0 mr-md-1 my-0 my-md-2 img-caracteristicas d-inline"
                                        width="30px"
                                        height="25px"
                                    />
                                    <p className="parrafo-hyundai mt-3 d-inline f-responsive-10">
                                        {caracteristica.Descripcion}
                                    </p>
                                </Col>
                            )
                        }
                    </Row>
                </Col>
            </Row>
            <Row>
                <Col xs={10} className="text-center mx-auto">
                    <img src={version.Imagen} alt={version.Version} className="img-fluid text-center my-4 my-md-5 mx-auto img-preview" />
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={10} className=" mx-auto parrafo-hyundai f-responsive-10" dangerouslySetInnerHTML={{ __html: version.Descripcion }}></Col>
            </Row>
            <Row>
                <Col xs={12} md={10} className=" mx-auto parrafo-hyundai f-responsive-10">
                    <Divider className='my-2' />
                    <Row className='my-0'>
                        <Col xs={7} md={6} lg={6} className="mx-0">
                            {/* <h6 className="bold-title-hyundai blue-text-hyundai f-responsive-14">
                                Desde: {moneda(tipoMoneda)}{version.Precio.toLocaleString('es-CL')} <span className="iva">+IVA</span>
                            </h6> */}
                            <h6 className="bold-title-hyundai blue-text-hyundai f-responsive-12">
                                Precio de lista sin IVA
                            </h6>
                        </Col>
                        <Col xs={5} md={6} lg={6} className="mx-0 text-right">
                            <h6 className="bold-title-hyundai blue-text-hyundai f-responsive-12">
                                {moneda(version.tipoMoneda) + version?.Precio?.toLocaleString('es-CL')}
                            </h6>
                        </Col>

                        <Col xs={7} md={6} lg={6} className="mx-0 m-0">
                            <h6 className="bold-title-hyundai blue-text-hyundai f-responsive-12">
                                Precio de lista con IVA
                            </h6>
                        </Col>
                        <Col xs={5} md={6} lg={6} className="mx-0 m-0 text-right">
                            <h6 className="bold-title-hyundai blue-text-hyundai f-responsive-12">
                                {moneda(version.tipoMoneda) + (version.PrecioIVA ? version?.PrecioIVA?.toLocaleString('es-CL') : '-')}
                            </h6>
                        </Col>
                    </Row>
                    <Divider className='my-1 my-lg-2' />
                </Col>
            </Row>

            {
                version?.Bono ?
                <Row>
                    <Col xs={12} md={10} className=" mx-auto parrafo-hyundai f-responsive-12">
                        <Row className='my-0'>
                            <Col xs={6} md={6} lg={6} className="mx-0 m-0">
                                <p className="parrafo-hyundai mt-3 d-inline f-responsive-12">
                                    Bono sin IVA
                                </p>
                            </Col>
                            <Col xs={6} md={6} lg={6} className="mx-0 m-0 text-right">
                                <p className="parrafo-hyundai mt-3 d-inline f-responsive-12">
                                    {moneda(version.tipoMoneda) + version?.Bono?.toLocaleString('es-CL')}
                                </p>
                            </Col>

                            <Col xs={6} md={6} lg={6} className="mx-0 m-0">
                                <p className="parrafo-hyundai mt-3 d-inline f-responsive-12 mb-0">
                                    Bono con IVA
                                </p>
                            </Col>
                            <Col xs={6} md={6} lg={6} className="mx-0 m-0 text-right">
                                <p className="parrafo-hyundai mt-3 d-inline f-responsive-12 mb-0">
                                    {moneda(version.tipoMoneda) + version?.BonoIVA?.toLocaleString('es-CL')}
                                </p>
                            </Col>
                        </Row>
                        <Divider className='my-1 my-lg-2' />
                        <Row className='my-0'>
                            <Col xs={7} md={6} lg={6} className="mx-0">
                                <h6 className="bold-title-hyundai blue-text-hyundai f-responsive-12">
                                    Precio final sin IVA
                                </h6>
                            </Col>
                            <Col xs={5} md={6} lg={6} className="mx-0 text-right">
                                <h6 className="bold-title-hyundai blue-text-hyundai f-responsive-12">
                                    {moneda(version.tipoMoneda) + version?.PrecioFinal?.toLocaleString('es-CL')}
                                </h6>
                            </Col>

                            <Col xs={7} md={6} lg={6} className="mx-0 m-0">
                                <h6 className="bold-title-hyundai blue-text-hyundai f-responsive-12 mb-0">
                                    Precio final con IVA
                                </h6>
                            </Col>
                            <Col xs={5} md={6} lg={6} className="mx-0 m-0 text-right">
                                <h6 className="bold-title-hyundai blue-text-hyundai f-responsive-12 mb-0">
                                    {moneda(version.tipoMoneda) + version?.PrecioFinalIVA?.toLocaleString('es-CL')}
                                </h6>
                            </Col>
                        </Row>
                        <Divider className='my-2' />
                    </Col>
                </Row>
                : ''
            }
            {
                version?.Legal &&
                <Row>
                    <Col
                         xs={12} md={10}
                        className="mx-auto mt-3 htmlHyundai parrafo-hyundai f-responsive-10"
                        dangerouslySetInnerHTML={{ __html: version?.Legal }}
                    >
                    </Col>
                </Row>
            }
        </Container>
    )
}

export default VersionesYPrecios;